import React from 'react';
import { useQuery } from '@apollo/client/react';
import M3Card from '../../M3Card';
import { PUBLICATIONS_QUERY } from '../../../graphql/queries';
import ActionTools from './ActionTools';
import OrganizationTools from './OrganizationTools';
import '../../../styles/analytics-tools.css';

/**
 * Tools panel of the analytics workspace: the legacy action features that
 * are not workflow charts — BOVW training, exports and bulk organization.
 * A publication is picked first; every tool acts on it.
 */
export default function ToolsPanel() {
  const [publicationId, setPublicationId] = React.useState('');
  const { data, loading } = useQuery(PUBLICATIONS_QUERY);
  const publications = (data && data.publications) || [];
  const active = publications.find((p) => p.id === publicationId) || publications[0];
  const selected = active ? active.id : '';

  return (
    <div className="analytics-tools">
      <M3Card variant="outlined">
        <M3Card.Header
          title="Publication"
          subtitle="The tools below act on the selected publication"
        />
        <M3Card.Body>
          {loading ? (
            <p className="text-muted">Loading publications…</p>
          ) : (
            <select
              className="sidebar-input"
              value={selected}
              onChange={(e) => setPublicationId(e.target.value)}
            >
              {publications.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title} ({p.author}, {p.year})
                </option>
              ))}
              {publications.length === 0 && <option value="">No publications</option>}
            </select>
          )}
        </M3Card.Body>
      </M3Card>

      {selected ? (
        <>
          <ActionTools publicationId={selected} />
          <OrganizationTools publicationId={selected} />
        </>
      ) : (
        <p className="text-muted">Pick a publication to use the tools.</p>
      )}
    </div>
  );
}
